import { DM_HOST, WALLET_HOST, FRAUDMETRIX_HOST } from '@/config/api'
export const countdown = (Vue) => {
  class CountDown {
    constructor (options = {
      text: '获取验证码',
      counter: 10,
      duration: 1000,
      update: null
    }) {
      this._options = Object.assign({
        text: '获取验证码',
        counter: 10,
        duration: 1000,
        update: null
      }, options)
      this._timer = null
      this._counter = this._options.counter
      this.text = this._options.text
      this.countdowning = false
    }
    // methods
    start () {
      this.countdowning = true
      if (this._options.update) {
        this._options.update({
          text: this.text,
          counter: this._counter,
          action: 'start'
        })
      }
      this._countdown()
    }

    _countdown () {
      this.text = this._counter
      if (this._options.update) {
        this._options.update({
          text: this.text,
          counter: this._counter,
          action: 'update'
        })
      }
      this._counter--
      if (this._counter >= 0) {
        this._timer = setTimeout(() => {
          this._countdown()
        }, this._options.duration)
      } else {
        this.text = this._options.text
        this.close()
      }
    }
    
    close (text) {
      this.countdowning = false
      this._counter = this._options.counter
      this.text = text || this._options.text
      if (this._options.update) {
        this._options.update({
          text: this.text,
          counter: this._counter,
          action: 'close'
        })
      }
      clearTimeout(this._timer)
    }
  }
  Vue.prototype.$countdown = (options) => {
    let _countdown = new CountDown(options);
    return _countdown
  }
}
export const trim = (Vue) => {
  Vue.prototype.$trim = (text) => {
    return (text || '').replace(/\s/ig, '')
  }
}
export const getConfig = () => {
  let pintecEnv = window.pintecEnv || {}
  if (!pintecEnv.hasOwnProperty('dm_host')) {
    window.pintecEnv = {
      dm_host: DM_HOST,
      wallet_host: WALLET_HOST
    }
  } else {
    window.pintecEnv = pintecEnv
  }
  return window.pintecEnv
}

export const cookie = (Vue) => {
  Vue.cookie = function (key, val, time) {
    if (typeof val == 'undefined') {
      // todo get cookie value
      var cookies = document.cookie.split(';');
      var result = '';
      cookies.forEach(function (val) {
        var pairs = val.split('=');
        if (pairs.length > 0) {
          var _key = pairs[0].replace(/^\s|\s$/ig, '');
          if (_key == key) {
            result = pairs.slice(1).join('=');
            return;
          }
        }
      });
      return result;
    } else {
      // todo set cookei value
      if (time) {
        var exp = new Date();
        try {
            var strsec = getSec(time);
            exp.setTime(exp.getTime() + strsec * 1);
        } catch (e) {
          // empty block
        }
        document.cookie = key + '=' + escape(val) + ';path=/;expires=' + exp.toGMTString();
      } else {
        document.cookie = key + '=' + escape(val) + ';path=/';
      }
    }
  }
}

export const gps = (win) => {
  if (win.navigator.geolocation) {
    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition((p) => {
        resolve({
          status: 200,
          data: {
            lng: p.coords.longitude,
            lat: p.coords.latitude
          } 
        })
      }, () => {
        resolve({
          status: 204
        })
      })
    })
  } else {
    return Promise.resolve({
      // 没有内容
      status: 204
    })
  }
}

export const fraudmetrix = (tokenId) => {
  (function() {
    window._fmOpt = {
        partner: 'jimubox',
        appName: 'jimubox_web',
        token: tokenId
    };
    var cimg = new Image(1,1);
    cimg.onload = function() {
        window._fmOpt.imgLoaded = true;
    };
    cimg.src = FRAUDMETRIX_HOST + "/fp/clear.png?partnerCode=jimubox&appName=jimubox_web&tokenId=" + window._fmOpt.token;
    var fm = document.createElement('script'); fm.type = 'text/javascript'; fm.async = true;
    fm.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'static.fraudmetrix.cn/fm.js?ver=0.1&t=' + (new Date().getTime()/3600000).toFixed(0);
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(fm, s);
  })();
}

function getSec(str) {
  var str1 = Number(str.substr(0, str.length - 1));
  var str2 = str.substr(str.length - 1, 1);
  if (str2 == "s") {
      return str1 * 1000;
  } else if (str2 == "h") {
      return str1 * 60 * 60 * 1000;
  } else if (str2 == "d") {
      return str1 * 24 * 60 * 60 * 1000;
  } else if (str2 == 'm') {
      return str1 * 30 * 24 * 60 * 60 * 1000;
  } else if (str2 == 'y') {
      return str1 * 12 * 30 * 24 * 60 * 60 * 1000;
  }
}
export const getCaller = () => {
  var caller = 3;
  var userAgent = window.navigator.userAgent;
  userAgent = userAgent.toLowerCase();
  if (userAgent.indexOf('iphone'.toLowerCase()) > -1 || userAgent.indexOf('ipad'.toLowerCase()) > -1 || userAgent.indexOf('ipod'.toLowerCase()) > -1) {
    caller = 2;
  }
  if (userAgent.indexOf('android'.toLowerCase()) > -1) {
    caller = 1;
  }
  if (userAgent.indexOf('micromessenger') > -1) {
    caller = 5;
  }
  return caller
}

export const trackRegister = (Vue) => {
  Vue.registerPage = function (product_id) {
    try {
      if (window.sensors) {
        if (Vue.cookie('userId')) {
          window.sensors.login(Vue.cookie('userId'));
        }
        let caller = Vue.cookie('caller');
        let platform = 'h5';
        if (caller == 13) {
            platform = 'Android';
        } else if (caller == 14) {
            platform = 'iOS';
        }
        window.sensors.registerPage({
            platform_type: platform,
            apply_id: Vue.cookie('applyId') || Vue.cookie('applyID') || "",
            channel: Vue.cookie('partner') || "H5_WALLET",
            product_id: product_id || 'DM-QBXJ'
        });
      }
    } catch (e) {
      window.console.error(e)
    }
  }
  Vue.sensorsTrack = (eventName, eventValue) => {
    try {
      if (window.sensors && window.location.host === 'w.idumiao.com') {
        if (Vue.cookie('userId')) {
          window.sensors.login(Vue.cookie('userId'));
        }
        window.sensors.track(eventName, eventValue);
      } else {
        //window.console.log(eventName, JSON.stringify(eventValue))
      }
    } catch (e) {
      window.console.error(e)
    }
  }
}